import {CompanyDTO} from "@energy-advice/easas-api";
import {useUserState} from "../store/user-store";

const useCurrentCompanyContext = (): CompanyDTO | undefined => {
    return useUserState((state) => state.companyContext)
};

export default useCurrentCompanyContext;
